export default __webpack_public_path__ + "static/media/IMG_4882.fb5f548f.png";